module.exports = __webpack_public_path__ + "static/img/logo-white.fa075e73.png";